export default {
    namespaced: true,

    state: {
        transactions: null,
    },

    getters: {
        hasTransactions: (state) => {
            return (state.transactions && state.transactions.length);
        },
    },

    actions: {
        getTransactions({ commit }, payload) {
            commit('setTransactions', null);

            return axios.get(`/api/contacts/leaseholder/properties/${payload.propertyPK}/estate/transactions`)
            .then((response) => {
                commit('setTransactions', response.data.data);
            })
            .catch(() => {
                commit('setTransactions', []);
            });
        },
    },

    mutations: {
        setTransactions(state, transactions) {
            state.transactions = transactions;
        },
    },
};
